import { RouteEntry } from "@/interfaces/route";
import { useUserStore } from "@/stores/use-user-store";

export const sharedRoutesEntries: RouteEntry[] = [
  {
    path: "",
    name: "Home",
    redirect: () => useUserStore.getState().initialRoute ?? undefined,
  },
  {
    name: "Public",
    path: "(public)",
    children: [
      { path: "login", name: "Login" },
      {
        path: "atualizar-dados",
        name: "Solicitação de atualização dos dados",
      },
      {
        path: "dev/table-test",
        name: "Table Test",
      },
    ],
  },
];
